import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { units } from "@m/alchemy-theme";
import { LinkIcon } from "../../../../icons/LinkIcon";
import { Field } from "../../../field/Field";
import { Input } from "../../../input/Input";
import { Dialog } from "../../../../dialog/Dialog";
import { useUniqueId } from "../../../../hooks/useUniqueId";
export const ImageUrlDialog = ({ onClose, onInsert, onPostDeactivate, insertImageUrl, isOpen }) => {
    const inputRef = useRef(null);
    const FORM_ID = useUniqueId("form");
    return (_jsx(Dialog, { headerContent: "Insert image from URL", isOpen: isOpen, onClose: onClose, focusTrapOptions: { returnFocusOnDeactivate: false, onPostDeactivate }, footerButtons: [
            {
                label: "Cancel",
                priority: "tertiary",
                onClick: onClose
            },
            {
                label: "Insert",
                form: FORM_ID,
                type: "submit"
            }
        ], children: _jsx("form", { style: { marginBottom: units(2) }, id: FORM_ID, onSubmit: (e) => {
                e.preventDefault();
                e.stopPropagation();
                const data = new FormData(e.currentTarget);
                const imageUrl = data.get("image_url");
                if (typeof imageUrl === "string" && imageUrl.length > 1) {
                    insertImageUrl(imageUrl);
                    onInsert(imageUrl);
                }
            }, children: _jsx(Field, { isFullWidth: true, startAdornment: _jsx(LinkIcon, { "aria-hidden": "true" }), label: "Image URL", input: _jsx(Input, { ref: inputRef, name: "image_url", placeholder: "Paste image url here" }) }) }) }));
};
